import React, { useState, FC } from 'react';
import { Button, InputAdornment, TextFieldProps } from '@bw/foundry';
import { FormikTextField } from 'components/formikBindings';

interface FormikPasswordFieldProps
  extends Omit<TextFieldProps, 'label' | 'name' | 'InputProps' | 'type'> {
  label?: string;
  name?: string;
  showText?: string;
  hideText?: string;
  includeShowHide?: boolean;
}
const FormikPasswordField: FC<FormikPasswordFieldProps> = ({
  label = 'Password',
  name = 'password',
  showText = 'Show',
  hideText = 'Hide',
  includeShowHide = true,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <FormikTextField
      label={label}
      name={name}
      type={showPassword ? 'text' : 'password'}
      {...rest}
      InputProps={
        includeShowHide
          ? {
              endAdornment: (
                <InputAdornment position="end">
                  <Button
                    variant="text"
                    type="button"
                    onClick={() => setShowPassword((val) => !val)}
                  >
                    {showPassword ? hideText : showText}
                  </Button>
                </InputAdornment>
              ),
            }
          : undefined
      }
    />
  );
};

export default FormikPasswordField;
